<template>
  <div class="right-table-3 card-background p-2">
    <!-- <dv-border-box-13 :color="[$color.borderColor, $color.borderColor]"> -->
    <div class="bc-chart-item table">
      <div class=""></div>
      <ComponentSubtitle>
        <span class="sub-title">健康互动栏</span></ComponentSubtitle
      >
      <div id="main" style="width: 480px; height: 330px"></div>
      <!-- <ComponentSubtitle>
        <span class="sub-title">人群患病风险分类</span>
      </ComponentSubtitle>

      <div id="risk-pie" style="width: 400px; height: 260px"></div> -->
      <DialogUserTable
        :show.sync="visible"
        :tableData="filterList"
        @onSelect="onCheckoutItemOfUser"
      ></DialogUserTable>
      <DialogArchivesCard
        :id="checkUsers.sn"
        :show.sync="visibleArchives"
        @back="visible = true"
      ></DialogArchivesCard>
    </div>
    <!-- </dv-border-box-13> -->
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import ComponentSubtitle from "./ComponentSubtitle.vue";
import DialogUserTable from "./DialogUserTable.vue";
import DialogArchivesCard from "./DialogArchivesCard.vue";
import * as echarts from "echarts";

export default {
  computed: {
    ...mapGetters(["globalData"]),
  },
  data() {
    return {
      config: {
        header: [],
        data: [],
        align: ["center"],
      },
      visible: false,
      list: [],
      filterList: [],
      visibleArchives: false,
      checkUsers: {},
    };
  },
  watch: {
    globalData: {
      handler(n, o) {
        this.$nextTick(async () => {
          // this.list = this.globalData["users"] || [];
          // this.filterList = this.globalData["users"];
          // this.initChart();
          this.initChart("main", await this.initWordCloudy());
        });
      },
    },
  },
  components: {
    ComponentSubtitle,
    DialogUserTable,
    DialogArchivesCard,
  },
  methods: {
    initChart(el, option) {
      var myChart = echarts.init(document.getElementById(el));
      myChart.setOption(option);
      if (el == "main") {
        myChart.on("click", (param) => {
          this.$router.push("/interaction");
        });
      }
    },

    getList() {
      return new Promise((resolve) => {
        this.$axios
          .get("/articleService/open/domain/list", {
            params: {
              typeIds: "4",
              mechanismId: "M57wVRNZ",
            },
          })
          .then(async (resp) => {
            let list = resp.data;
            if (list.length > 4) {
              list = list.slice(0, 4);
            }
            let titleData = [];
            for (let i = 0; i < list.length; i++) {
              let response = await this.getArticleList({
                moduleId: list[i].moduleId,
              });
              response.list.map((v) => {
                titleData.push(v);
              });
            }
            resolve(titleData);
          });
      });
    },

    getArticleList(params) {
      return new Promise((resolve) => {
        this.$axios
          .get("/articleService/open/article/paginate", {
            params,
          })
          .then((resp) => {
            resolve(resp.data);
          });
      });
    },
    async initWordCloudy() {
      let titleData = await this.getList();
      titleData = titleData.map((v) => {
        return {
          name: v.title,
          value: Math.floor(Math.random() * (100 - 1 + 1)) + 1,
        };
      });
      let colorList = [
        "#ff9597",
        "#22cfe0",
        "#b9b1f0",
        "#51b7fb",
        "#76e68f",
        "#fa8b54",
        "#ffc545",
        "#ffd9a6",
      ];
      let option = {
        tooltip: {
          show: true,
        },
        series: [
          {
            type: "wordCloud", //词云图
            left: "0%", // X轴偏移量
            top: "10%", // Y轴偏移量
            width: "100%", // canvas宽度大小
            height: "100%", // canvas高度大小
            sizeRange: [12, 30], //  词典字体大小范围配置
            rotationRange: [0, 0], // 词典字体旋转角度配置，默认不旋转
            gridSize: 12, // 词典字体间距配置
            layoutAnimation: true, // 为false词典过度会阻塞
            textStyle: {
              fontFamily: "sans-serif",
              fontWeight: "bold",
              // Color可以是一个回调函数或一个颜色字符串
              color: function () {
                let index = Math.floor(Math.random() * colorList.length);
                return colorList[index];
              },
            },

            emphasis: {
              focus: "self",

              textStyle: {
                // textShadowBlur: 10,
                // textShadowColor: "#333",
              },
            },
            // color: ["#f00", "#0f0", "#00f"],
            layoutAnimation: true,
            data: titleData,
            // data: [
            //   // {
            //   //   name: "骨质疏松？可能并不只是因为老了而已！",
            //   //   value: 15,
            //   // },
            //   // {
            //   //   name: "可不能一“钙”而论！",
            //   //   value: 19,
            //   // },
            //   // {
            //   //   name: "总是膝盖关节痛腿痛？",
            //   //   value: 29,
            //   // },
            // ],
          },
        ],
      };
      return option;
    },
    onCheckoutItemOfUser(row) {
      this.checkUsers = row;
      // this.getArchivesDetail();
      this.visible = false;
      this.visibleArchives = true;
      return;
    },

    formatRiskLevel(level = 1) {
      let map = new Map([
        [0, `<span style="color:#34C724;">基本健康人群</span>`],
        [1, `<span style="color:#34C724;">基本健康人群</span>`],
        [2, `<span style="color:#FF8800;">专项关爱人群</span>`],
        [3, `<span style="color:#F54A45;">重点关爱人群</span>`],
      ]);
      return map.get(level);
    },
    // initChart() {
    //   let userList = this.globalData["users"];
    //   var getname = ["基本健康人群", "专项关爱人群", "重点关爱人群"];
    //   let getvalue = [0, 0, 0];
    //   userList.map((v) => {
    //     if (v.riskLevel == 2) {
    //       getvalue[1] += 1;
    //     } else if (v.riskLevel == 3) {
    //       getvalue[2] += 1;
    //     } else {
    //       getvalue[0] += 1;
    //     }
    //   });
    //   var getbl = getvalue.map((v) => (v / userList.length) * 100);
    //   var data = [];

    //   for (var i = 0; i < getname.length; i++) {
    //     data.push({ name: getname[i], value: getvalue[i] });
    //   }

    //   var colorList = ["#34C724", "#FF8800", "#F54A45"];

    //   let option = {
    //     tooltip: {
    //       trigger: "item",

    //       show: true,
    //     },

    //     legend: {
    //       type: "scroll",

    //       orient: "vertical",

    //       height: "88%",

    //       right: "6%",

    //       top: "center",

    //       icon: "circle",

    //       itemWidth: 10,

    //       itemHeight: 10,

    //       itemGap: 10,

    //       data: getname,
    //       color: "#fff",
    //       formatter: function (name, list) {
    //         console.log(name);
    //         for (var i = 0; i < getname.length; i++) {
    //           if (name == data[i].name) {
    //             return (
    //               "{name|" +
    //               name +
    //               "}{value|" +
    //               getvalue[i] +
    //               "人}{rate|" +
    //               getbl[i].toFixed(0) +
    //               "%}"
    //             );
    //           }
    //         }
    //       },

    //       textStyle: {
    //         rich: {
    //           name: {
    //             fontSize: 13,

    //             fontWeight: 400,

    //             width: 80,

    //             height: 35,

    //             padding: [0, 0, 0, 10],

    //             // color: "#6395CA",
    //             color: this.$color.borderColor,
    //           },

    //           value: {
    //             fontSize: 13,

    //             fontWeight: 400,

    //             width: 50,

    //             height: 35,

    //             //padding:[0,0,0,1],

    //             // color: "#6395CA",
    //             color: this.$color.borderColor,
    //           },

    //           rate: {
    //             fontSize: 13,

    //             fontWeight: 500,

    //             height: 35,

    //             width: 55,

    //             align: "left",

    //             // color: "#6395CA",

    //             color: this.$color.borderColor,
    //           },
    //         },
    //       },
    //     },

    //     series: [
    //       {
    //         type: "pie",

    //         radius: ["35%", "55%"],

    //         center: ["25%", "50%"],

    //         itemStyle: {
    //           normal: {
    //             color: function (params) {
    //               return colorList[params.dataIndex];
    //             },
    //           },
    //         },

    //         label: {
    //           normal: {
    //             show: false,
    //           },
    //         },

    //         labelLine: {
    //           normal: {
    //             show: false,
    //           },
    //         },

    //         data: data,
    //       },
    //     ],
    //   };
    //   var myChart = echarts.init(document.getElementById("risk-pie"));
    //   myChart.setOption(option);
    //   myChart.on("click", (params) => {
    //     console.log(params);
    //     this.visible = true;
    //     if (params.name == "基本健康人群") {
    //       this.filterList = this.list.filter(
    //         (v) => !v.riskLevel || v.riskLevel == 1
    //       );
    //     }
    //     if (params.name == "专项关爱人群") {
    //       this.filterList = this.list.filter((v) => v.riskLevel == 2);
    //     }
    //     if (params.name == "重点关爱人群") {
    //       this.filterList = this.list.filter((v) => v.riskLevel == 3);
    //     }
    //     console.log("filterList", this.filterList);
    //   });
    // },
  },
  mounted() {
    // this.initTable();
  },
};
</script>
<style lang="less" scoped>
.right-table-3 {
  height: 440px;
  background: #fff;
  margin-top: 10px;
}
.table {
  // padding: 20px 0px 0 0;
}
</style>
